import BlockModel from '../BlockModel'
import BlockConceptLabModel from './BlockConceptLabModel'
import BlockTrackingValuesModel from './BlockTrackingValuesModel'

const BLOCK_MODELS_LIST = [
  [BlockConceptLabModel, BlockConceptLabModel.blockType],
  [BlockTrackingValuesModel, BlockTrackingValuesModel.blockType]
]

const BLOCK_MODELS_MAP = BLOCK_MODELS_LIST.reduce((map, [model, type]) => ((map[type] = model), map), {})

export default function getBlockModelByType(type) {
  return BLOCK_MODELS_MAP[type] || BlockModel
}

export function listBlockModels() {
  return BLOCK_MODELS_LIST
}
